import React from "react";
import { Autocomplete, Grid, TextField } from "@mui/material";

const CustomFilterComponent = ({
  filterOptions,
  onFilterChange,
  filterTypes,
}) => {
  const renderFilter = (filterType) => {
    const options = filterOptions[filterType.id] || [];
    return (
      <Autocomplete
        key={filterType.id}
        disablePortal
        options={options}
        className="dropdown-list"
        size="small"
        onChange={(event, value) => onFilterChange(filterType.id, value)}
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option.label || option.name
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={filterType.label}
            sx={{ minWidth: "300px" }}
          />
        )}
      />
    );
  };

  return (
    <div>
      <Grid
        container
        md={12}
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gridGap: "10px",
          alignItems: "flex-end",
        }}
      >
        <Grid md={4}>
          <Autocomplete
            multiple
            options={filterTypes.filter(
              (type) =>
                !filterOptions.selectedFilters?.some((f) => f.id === type.id)
            )}
            getOptionLabel={(option) => option.label}
            value={filterTypes?.filter((type) =>
              filterOptions?.selectedFilters?.some((f) => f.id === type.id)
            )}
            onChange={(event, newValues) => {
              const updatedFilters = newValues.map((v) => {
                const existingFilter = filterOptions.selectedFilters?.find(
                  (f) => f.id === v.id
                );
                return {
                  id: v.id,
                  label: v.label,
                  value: existingFilter?.value || [],
                };
              });

              onFilterChange("selectedFilters", updatedFilters);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Filters"
                fullWidth
                sx={{ minWidth: "300px" }}
                size="small"
              />
            )}
          />
        </Grid>

        {filterOptions.selectedFilters &&
          filterOptions.selectedFilters.map((filter) => (
            <Grid key={filter.id} md={3}>
              {renderFilter({
                ...filter,
                id: filter.id,
              })}
            </Grid>
          ))}
      </Grid>
    </div>
  );
};

export default CustomFilterComponent;
